// Copy of the mandatory "complete your profile" step (spec 028).
export const profileCompletionCopy = {
  fr: {
    title: "Complétez votre profil",
    intro:
      "Avant de continuer, nous avons besoin de quelques informations. Elles nous aident à constituer des données équilibrées.",
    gender: "Sexe",
    country: "Pays",
    countryPlaceholder: "Choisir un pays",
    countrySearch: "Rechercher un pays",
    countryNotFound: "Aucun pays trouvé",
    save: "Enregistrer et continuer",
    saving: "Enregistrement…",
    logout: "Se déconnecter",
    required: "Renseignez tous les champs pour continuer.",
    error: "L'enregistrement a échoué. Réessayez dans un instant.",
  },
  en: {
    title: "Complete your profile",
    intro:
      "Before you continue, we need a few details. They help us build balanced data.",
    gender: "Sex",
    country: "Country",
    countryPlaceholder: "Choose a country",
    countrySearch: "Search a country",
    countryNotFound: "No country found",
    save: "Save and continue",
    saving: "Saving…",
    logout: "Sign out",
    required: "Fill in every field to continue.",
    error: "Saving failed. Try again in a moment.",
  },
} as const;

export type ProfileCompletionCopy = (typeof profileCompletionCopy)["fr"];
